type Operation = {
  op: "+" | "-"
  val: number
}

type CalculationInput = {
  deducted_amount?: Operation
} & Record<string, Operation>

export const calculateFinalAmount = (data: CalculationInput): number => {
  const { deducted_amount, ...operations } = data

  return Object.values(operations).reduce((total, { op, val }) => {
    return op === "+" ? total + val : total - val
  }, deducted_amount?.val || 0)
}
